import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import RepairUrgentList from './components/RepairUrgentList';

const { Cell } = ResponsiveGrid;

const RepairBudget = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="緊急修繕預算表"
        breadcrumbs={[
          {
            name: '緊急修繕預算',
          },
          {
            name: '緊急修繕預算表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <RepairUrgentList />
    </Cell>
  </ResponsiveGrid>
);

export default RepairBudget;
